import { render, staticRenderFns } from "./dialogUpdateGroupName.vue?vue&type=template&id=15b5091e&scoped=true"
import script from "./dialogUpdateGroupName.vue?vue&type=script&lang=js"
export * from "./dialogUpdateGroupName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b5091e",
  null
  
)

export default component.exports